import script from "./input-sn.vue?vue&type=script&lang=ts&setup=true"
export * from "./input-sn.vue?vue&type=script&lang=ts&setup=true"

import "./input-sn.vue?vue&type=style&index=0&id=65d5a9c4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d5a9c4"]])

export default __exports__